import { View, Dialog } from "../base";
import { AllowedOriginsSettingsForm, AllowedOriginsSettingsFormData } from "./AllowedOriginsSettingsForm";

type AllowedOriginsSettingsDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  config: AllowedOriginsSettingsFormData;
  onChange: (key: string) => (value: unknown) => void;
};

export const AllowedOriginsSettingsDialog = ({ isOpen, onClose, config, onChange }: AllowedOriginsSettingsDialogProps) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Allowed Origins"
      size="flex"
      className="w-full max-w-[600px] min-w-0 max-h-[90vh] mx-4"
    >
      <View className="p-4 sm:p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
        <AllowedOriginsSettingsForm
          config={config}
          onChange={onChange}
        />
      </View>
    </Dialog>
  );
};
